mobileSize = 900;

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 900) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 901) {
    $('body').removeClass('saffireMobileSize');
  }
  const fes1 = $('.subscribe-container .emailSignup ');
  fes1.find('.emailInputSubmit a').text('SUBSCRIBE');
  fes1.find('.inputFieldTextbox').val('');
  fes1.find('.inputFieldTextbox').attr('placeholder', 'Email Address');
  // General Message
  $('.generalmessage').prependTo('header');
  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');

});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');
});